import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import reportWebVitals from './reportWebVitals';
import {ApolloClient, ApolloProvider, InMemoryCache} from "@apollo/client";
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import {QueryPage} from "./components/pages/QueryPage/QueryPage";
import {AuthProvider, link} from "./AuthContext/authContext";
import {MatchupTeamsPage} from "./components/pages/MatchupTeamsPage/MatchupTeamsPage";
import HomePage from "./components/pages/Homepage/HomePage";
import {TrendFinderPage} from "./components/pages/TrendFinderPage/TrendFinderPage";
import AuthSuccess from "./AuthContext/authSuccess";
import {AboutPage} from "./components/pages/AboutPage/AboutPage";
import {MyTrendsPage} from "./components/pages/MyTrendsPage/MyTrendsPage";
import {TutorialsPage} from "./components/pages/TutorialsPage/TutorialsPage";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
});

const theme = createTheme({
    typography: {
        fontFamily: 'Helvetica Neue:',
    },
});


const AuthProviderWrapper = ({children}: { children: any }) => {
    const location = useLocation();

    return <AuthProvider currentLocation={location.pathname.replace('/', '')}>{children}</AuthProvider>;
};


root.render(
    <React.StrictMode>
            <ApolloProvider client={client}>
                <Router>
                    <AuthProviderWrapper>
                        <ThemeProvider theme={theme}>
                                <Routes>
                                    <Route path="/" element={<HomePage/>}/>
                                    <Route path="/nba" element={<HomePage/>}/>
                                    <Route path="/ncaafb" element={<HomePage/>}/>
                                    <Route path="/nfl" element={<HomePage/>}/>
                                    <Route path="/ncaabb" element={<HomePage/>}/>
                                    <Route path="/mlb" element={<HomePage/>}/>
                                    <Route path="/cbb/matchupTeams/:matchupId" element={<MatchupTeamsPage/>}/>
                                    <Route path="/ncaafb/matchupTeams/:team/:oTeam/:date" element={<MatchupTeamsPage/>}/>
                                    <Route path="/nba/matchupTeams/:team/:oTeam/:date" element={<MatchupTeamsPage/>}/>
                                    <Route path="/nfl/matchupTeams/:team/:oTeam/:date" element={<MatchupTeamsPage/>}/>
                                    <Route path="/ncaabb/matchupTeams/:team/:oTeam/:date" element={<MatchupTeamsPage/>}/>
                                    <Route path="/mlb/matchupTeams/:team/:oTeam/:date" element={<MatchupTeamsPage/>}/>
                                    <Route path="/ncaabb-query" element={<QueryPage/>}/>
                                    <Route path="/ncaafb-query" element={<QueryPage/>}/>
                                    <Route path="/ncaafb-trend-finder" element={<TrendFinderPage/>}/>
                                    <Route path="/nba-trend-finder" element={<TrendFinderPage/>}/>
                                    <Route path="/ncaabb-trend-finder" element={<TrendFinderPage/>}/>
                                    <Route path="/nfl-trend-finder" element={<TrendFinderPage/>}/>
                                    <Route path="/nba-query" element={<QueryPage/>}/>
                                    <Route path="/nfl-query" element={<QueryPage/>}/>
                                    <Route path="/about" element={<AboutPage/>}/>
                                    <Route path="/my-trends" element={<MyTrendsPage/>}/>
                                    <Route path="/tutorials" element={<TutorialsPage/>}/>
                                    <Route path="/auth-success" element={<AuthSuccess/>}/>
                                </Routes>
                        </ThemeProvider>
                    </AuthProviderWrapper>
                </Router>
            </ApolloProvider>
    </React.StrictMode>
);

reportWebVitals();
